import Header from "components/layout/Header";
import { Col, Typography } from "antd";
import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";

import { useRecuringEventColumns, useRecuringEventList } from "./hooks";

const RecuringEventList = () => {
  const { dataSource, loading, pagination, onChange } = useRecuringEventList();
  const { columns } = useRecuringEventColumns();

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Recuring Events" />
          </Typography.Title>
        </Col>
        <Col>
          <ButtonLink type="primary" block to={ROUTE_PATHS.RecuringEvents}>
            <FormattedMessage defaultMessage="Create new recuring event" />
          </ButtonLink>
        </Col>
      </Header>
      <Table
        rowKey="id"
        {...{ dataSource, pagination, columns, loading, onChange }}
      />
    </>
  );
};

export default RecuringEventList;
